/* Pawsome Plushies — front-end fixes (standalone, additive).
   1) Move the mobile menu out to <body> so its z-index is not trapped inside the
      header section's stacking context — that trapping made it paint/hit-test
      BELOW the cart-drawer + quick-add layers, so it looked see-through and taps
      fell through to the page behind.
   2) Switch the PDP gallery to the selected variant's linked image.
   3) Inject a real star-rating badge (Judge.me data) next to the PDP price. */
(function () {
  function fixMobileNav() {
    var nav = document.querySelector('[data-mobile-nav]');
    if (nav && nav.parentNode !== document.body) {
      document.body.appendChild(nav);
    }
  }

  function initVariantImage() {
    var product = document.querySelector('[data-product]');
    if (!product) return;
    var stage = product.querySelector('[data-gallery-stage]');
    var data = product.querySelector('[data-variants-json]');
    if (!stage || !data) return;
    var variants = [];
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }
    var optionInputs = Array.prototype.slice.call(product.querySelectorAll('[data-product-option]'));
    var thumbs = Array.prototype.slice.call(product.querySelectorAll('[data-gallery-thumb]'));
    var dots = Array.prototype.slice.call(product.querySelectorAll('[data-gallery-dot]'));

    function currentOptions() {
      var map = {};
      optionInputs.forEach(function (inp) {
        if (inp.type === 'radio') { if (inp.checked) map[inp.name] = inp.value; }
        else map[inp.name] = inp.value;
      });
      return map;
    }
    function findVariant() {
      var opts = currentOptions();
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === opts['option' + (i + 1)]; });
      });
    }
    function setActive(idx) {
      thumbs.forEach(function (t) { t.classList.toggle('is-active', +t.getAttribute('data-index') === idx); });
      dots.forEach(function (d) { d.classList.toggle('is-active', +d.getAttribute('data-index') === idx); });
    }
    function showVariantImage() {
      var v = findVariant();
      if (!v || !v.featured_image || !v.featured_image.position) return;
      var idx = v.featured_image.position - 1;
      var slide = stage.children[idx];
      if (!slide) return;
      stage.scrollTo({ left: slide.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
      setActive(idx);
    }
    optionInputs.forEach(function (inp) { inp.addEventListener('change', showVariantImage); });
  }

  /* PDP star badge — reads the Judge.me review data Shopify inlines on the page
     (jdgm.data.reviewWidget[productId], written from the reviews metafield), so
     the number shown is always the app's real aggregate. Renders nothing when a
     product has no reviews. */
  function initPdpRating() {
    var row = document.querySelector('.pdp__price-row');
    /* The theme now server-renders this product's own stars under the title
       (.pdp__stars); this stays as the fallback for when it didn't. */
    if (!row || row.querySelector('.pdp__rating') || document.querySelector('.pdp__stars')) return;
    var store = window.jdgm && window.jdgm.data && window.jdgm.data.reviewWidget;
    if (!store) return;
    var pid = Object.keys(store)[0];
    if (!pid) return;
    var w = store[pid];
    var n = parseInt(w.number_of_reviews, 10) || 0;
    var avg = Math.round((parseFloat(w.average_rating) || 0) * 10) / 10;
    if (n < 1) return;
    var a = document.createElement('a');
    a.className = 'pdp__rating';
    a.href = '#judgeme_product_reviews';
    a.style.textDecoration = 'none';
    a.setAttribute('aria-label', 'Rated ' + avg + ' out of 5 from ' + n + ' reviews. Jump to reviews.');
    a.innerHTML = '<svg class="icon" viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true"><path d="M12 2l2.9 6.26 6.6.7-4.9 4.5 1.35 6.54L12 16.9 6.05 20l1.35-6.54-4.9-4.5 6.6-.7z"/></svg> <span>' + avg + '/5 · ' + n + ' review' + (n === 1 ? '' : 's') + '</span>';
    row.appendChild(a);
  }

  function init() {
    fixMobileNav();
    initVariantImage();
    initPdpRating();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
